<template>
	<v-dialog v-model="openDialog">
		<div class="dialog-container" :class="$attrs.class" v-click-outside="closeClicked">

			<div>
				<div class="d-flex flex-row justify-space-between">
					<span v-if="enableBack" class="d-flex pointer pa-2 align-self-start" v-ripple @click="backClicked">
						<v-icon>
							<back class="mr-1"></back>
						</v-icon>
						Back
					</span>


					<span @click="closeClicked" v-ripple class="pointer pa-2 align-self-end close-btn"
						style="position: absolute; top: 0px; right: 0px;">
						<v-icon>mdi-close</v-icon>
					</span>
				</div>



				<div>
					<slot></slot>
				</div>
			</div>



			<div class="append-bottom-wrapper d-flex align-center justify-center">
				<slot name="append-bottom"></slot>
			</div>




		</div>
	</v-dialog>
</template>



<script setup>

import { inject } from 'vue';
import Back from '@/icons/Back.vue';

const props = defineProps({
	enableBack: {
		type: Boolean,
		default: false
	},
});

const emit = defineEmits(['back', 'close']);
const openDialog = inject('openDialog');

const backClicked = () => {
	emit('back');
};

const closeClicked = () => {
	emit('close');
	openDialog.value = false;
};

</script>



<style scoped lang="scss">
@use "@/assets/scss/utilities/background" as *;

.dialog-container {
	@extend .background-tile-big;
	position: relative;
	overflow: auto;
	overflow-x: hidden;
	border-top: vars.get-map-value(vars.$border, dialog);
	width: 568px;
	max-width: 100%;
	margin: 0 auto;
	box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.60);
	border-radius: 24px;

	/* Hide scrollbar for Chrome, Safari and Opera */
	&::-webkit-scrollbar {
		display: none;
	}

	/* Hide scrollbar for IE, Edge and Firefox */
	-ms-overflow-style: none;  /* IE and Edge */
	scrollbar-width: none;  /* Firefox */

	@media screen and (max-width: vars.get-map-value(vars.$breakpoints, 'mobile')) {
		border-radius: 12px;
	}

	>div:first-child {
		padding: 30px;

		@media screen and (max-width: vars.get-map-value(vars.$breakpoints, 'mobile')) {
			padding: 20px;
		}
	}
}

.append-bottom-wrapper {
	// position: sticky;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	z-index: 1;
}

.close-btn {
	z-index: 2;
}
</style>
